import './progressBar.css'
export default function ProgressBar({ width, height, background, zIndex }: { width?: string, height?:string, background?: string, zIndex?: string }) {
  return (
    <div className='container-loader' style={{ width: width || '100%', height: height ||'100%', background: background || '', zIndex: zIndex || '10000' }}>
      <span className="loader"></span>
    </div>
  )
}
